import { telephoneRequiredStoreIds } from "application/constants/app-constants";
import { includes } from "ramda";
import { getMarket } from ".";

export default function isFromGermany() {
  return includes(parseInt(getMarket()), telephoneRequiredStoreIds);
}